import OnboardingHeader from './OnboardingHeader';
export default OnboardingHeader;